export default __webpack_public_path__ + "assets/14cce77edb12c17f5ccae158fb53ef68.png";